import firebase from 'firebase/app';
import 'firebase/functions';
import { fromFirestore, toFirestore, toFirestoreFunction } from '../support/FirestoreConversion';
export default class FirebaseCrmIntegrationServiceProvider {
    //Functions
    async call(func, data) {
        let result = await firebase.functions().httpsCallable(toFirestoreFunction(func))(data ? toFirestore(data) : undefined);
        if (result.data !== null) {
            return fromFirestore(result.data);
        }
        return new Map();
    }
}
//# sourceMappingURL=FirebaseCrmIntegrationServiceProvider.js.map